import { Controller } from "@hotwired/stimulus"

// The admin menu as a drawer (shared/_admin_sidebar): its arrow slides it
// away to a strip down the side, and back. A cookie keeps it that way on the
// next page; the layout reads it, so a closed menu doesn't flash open.
export default class extends Controller {
  static targets = ["button"]

  toggle() {
    const closed = this.element.classList.toggle("is-collapsed")
    document.cookie = `adm_drawer=${closed ? "closed" : "open"}; path=/; max-age=31536000; samesite=lax`
    this.buttonTarget.setAttribute("aria-expanded", String(!closed))
    this.buttonTarget.setAttribute("aria-label", closed ? "Show the admin menu" : "Hide the admin menu")
    this.buttonTarget.title = closed ? "Show the admin menu" : "Hide the admin menu"
  }
}
